const { populate } = require('@/functions/objects');
const {
    toInt,
    toIntArray,
    toNullableInt,
    toNullableString,
    toString,
} = require('@/functions/transform');

class OptionSet {
    constructor(data = {}) {
        /**
         * @type {number}
         */
        this.ID = undefined;

        /**
         * @type {string}
         */
        this.ref = '';

        this.minOptions = 0;
        this.maxOptions = null;

        /**
         * @type {string}
         */
        this.name = '';

        /**
         * @type {string|null}
         */
        this.shortName = null;

        /**
         * @type {number[]}
         */
        this.itemIDs = [];

        /**
         * @type {number[]}
         */
        this.optionIDs = [];

        /**
         * @type {string}
         */
        this.status = 'Active';

        populate(this, data);

        /**
         * This is populated only by ItemOptionManager when loading options for an item.
         *
         * @type {ItemOption[]|null}
         */
        this.options = null;
    }

    getHydrationMap() {
        return {
            ID: {
                field: ['optionSetID', 'ID'],
                transform: toInt,
            },
            itemIDs: toIntArray,
            optionIDs: toIntArray,
            minOptions: toInt,
            maxOptions: toNullableInt,
            name: toString,
            ref: toNullableString,
            shortName: toNullableString,
            status: toString,
        };
    }

    get required() {
        return this.minOptions > 0;
    }
}

module.exports = OptionSet;
